import styled from "styled-components";

const sizes = {
  large: 'font-size: 20px; @media (min-width: 724px) { font-size: 34px; line-height: 48px; }',
  medium: 'font-size: 16px; line-height: 24px;',
  small: 'font-size: 14px; line-height: 20px;',
}

const colors = {
  text: "gray500",
  textLight: "gray450",
  primary: "blue400",
  green: "green200"
}

export const Text = styled.p`
  display: flex;
  ${({ theme, weight= "regular"}) => theme.fontWeight[weight]}
  align-items: center;
  ${({ theme, size = "medium"}) => (sizes[size])};
  color: ${({ theme, color = "text" }) => theme.colors[colors[color]]};
  margin: 0px;
`